import { render, staticRenderFns } from "./asset-pie.vue?vue&type=template&id=5731236a"
import script from "./asset-pie.vue?vue&type=script&lang=js"
export * from "./asset-pie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports